import type { ComponentType } from "react"
import { createContext } from "react"

/**
 * Modals are represented as react components
 *
 * This is what gets passed to useModal as the first argument.
 */
export interface ModalType<Props> {
	component: ComponentType<Props>
	isOpen: boolean
	props: Props
}

/**
 * The shape of the modal context
 */
interface ModalContextType<Props> {
	hideModal(key: string): void
	isOpen(key: string): boolean
	showModal(key: string, component: ComponentType<Props>, props: Props): void
}

/**
 * Throw error when ModalContext is used outside of context provider
 */
const invariantViolation = () => {
	throw new Error(
		"Attempted to call useModal outside of modal context. Make sure your app is rendered inside ModalProvider.",
	)
}

export const ModalContext = createContext<ModalContextType<any>>({
	hideModal: invariantViolation,
	isOpen: invariantViolation,
	showModal: invariantViolation,
})
